import { useState } from "react";
import React from "react";
import Icon from "../components/Icon";
import { fmt, calcEstimateTotal, generateReportHTML } from "../utils";

function Reports({ t, estimates, invoices, customers, settings, priceList }) {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [docType, setDocType] = useState("estimates");
  const [toast, setToast] = useState(null);
  const REPORT_CONFIG_DEFAULT = {showLineItems:true,showUnitCost:true,showUnitPrice:true,showLineItemTotals:true,showSectionSubtotals:true,showTaxes:true};
  const PROD_CONFIG_DEFAULT = {showLineItems:true,showUnitCost:true,showUnitPrice:true,showLineItemTotals:true,showSectionSubtotals:true,showTaxes:true,showSupplier:true};
  const [reportModalDoc, setReportModalDoc] = useState(null); // {doc, label, isProd}
  const [reportConfig, setReportConfig] = useState(REPORT_CONFIG_DEFAULT);
  const [reportPreset, setReportPreset] = useState("full");
  const applyReportPreset = (preset) => {
    setReportPreset(preset);
    if (preset==="full") setReportConfig(p=>({...p,showLineItems:true,showUnitCost:true,showUnitPrice:true,showLineItemTotals:true,showSectionSubtotals:true,showTaxes:true}));
    else if (preset==="client") setReportConfig(p=>({...p,showLineItems:false,showUnitCost:false,showUnitPrice:false,showLineItemTotals:false,showSectionSubtotals:true,showTaxes:true}));
  };

  const source = docType === "invoices" ? (invoices||[]) : estimates;
  const filtered = source.filter(e=>{const c=customers.find(x=>x.id===e.customerId);return `${e.title} ${c?c.firstName:""} ${c?c.lastName:""}`.toLowerCase().includes(search.toLowerCase())&&(!statusFilter||e.status===statusFilter);});

  const generate = (type, doc) => {
    if (type === t.reports.estimate) {
      setReportConfig(REPORT_CONFIG_DEFAULT);
      setReportPreset("full");
      setReportModalDoc({doc, label: type, isProd: false});
      return;
    }
    if (type === t.reports.production) {
      setReportConfig(PROD_CONFIG_DEFAULT);
      setReportPreset("full");
      setReportModalDoc({doc, label: type, isProd: true});
      return;
    }
    const customer = customers.find(c=>c.id===doc.customerId);
    const html = generateReportHTML(type, doc, customer, settings, undefined, priceList);
    const win = window.open("","_blank","width=960,height=800,scrollbars=yes");
    if (win) { win.document.write(html); win.document.close(); }
    else { setToast("Autorisez les popups pour générer les rapports / Allow popups to generate reports"); setTimeout(()=>setToast(null),3000); }
  };
  const doGenerateReport = () => {
    if (!reportModalDoc) return;
    const customer = customers.find(c=>c.id===reportModalDoc.doc.customerId);
    const html = generateReportHTML(reportModalDoc.label, reportModalDoc.doc, customer, settings, reportConfig, priceList);
    const win = window.open("","_blank","width=960,height=800,scrollbars=yes");
    if (win) { win.document.write(html); win.document.close(); }
    else { setToast("Autorisez les popups pour générer les rapports / Allow popups to generate reports"); setTimeout(()=>setToast(null),3000); }
    setReportModalDoc(null);
  };

  return (
    <div>
      <div className="page-header"><div className="page-header-row"><div><h1>{t.reports.title}</h1><p>{t.reports.subtitle}</p></div></div></div>
      <div className="page-body">
        {/* Doc type toggle */}
        <div style={{display:"flex",gap:2,marginBottom:12,background:"var(--card)",borderRadius:10,border:"1px solid var(--border)",padding:4,width:"fit-content"}}>
          {[{k:"estimates",l:t.nav.estimates},{k:"invoices",l:t.nav.invoices}].map(o=>(
            <button key={o.k} onClick={()=>{setDocType(o.k);setStatusFilter("");setSearch("");}} style={{
              padding:"6px 16px",background:docType===o.k?"var(--red)":"transparent",
              color:docType===o.k?"white":"var(--text-2)",border:"none",borderRadius:7,
              cursor:"pointer",fontSize:13,fontWeight:600,fontFamily:"var(--font-body)",
            }}>{o.l}</button>
          ))}
        </div>
        <div className="toolbar">
          <div className="search-wrap"><Icon name="search"/><input className="search-input" placeholder={t.reports.search} value={search} onChange={e=>setSearch(e.target.value)}/></div>
          <select className="filter-select" value={statusFilter} onChange={e=>setStatusFilter(e.target.value)}>
            <option value="">{t.reports.allStatuses}</option>
            {(docType==="invoices"?["Draft","Sent","Paid"]:["Draft","Sent","Approved","Rejected"]).map(s=><option key={s}>{s}</option>)}
          </select>
        </div>
        <div className="card">
          {filtered.map(e=>{
            const c=customers.find(x=>x.id===e.customerId);
            const reportBtns = docType==="invoices"
              ? [{k:"invoice",label:t.reports.invoice}]
              : [{k:"estimate",label:t.reports.estimate},{k:"production",label:t.reports.production}];
            return (
              <div key={e.id} className="list-row">
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontWeight:600,fontSize:14}}>{e.title}</span>
                    <span className="badge badge-gray">{e.status}</span>
                    <span style={{fontSize:12,color:"var(--text-3)"}}>{e.number}</span>
                    {docType==="invoices"&&<span style={{fontSize:11,fontWeight:600,padding:"2px 8px",borderRadius:10,background:e.isPublished?"var(--green-bg)":"var(--bg)",color:e.isPublished?"var(--green)":"var(--text-3)"}}>{e.isPublished?"Publié":"Masqué"}</span>}
                  </div>
                  <div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>
                    {c&&<span>{c.firstName} {c.lastName}</span>}
                    <span className="green-text" style={{marginLeft:8}}>{fmt(calcEstimateTotal(e))}</span>
                  </div>
                </div>
                <div style={{display:"flex",gap:6,marginLeft:"auto",alignItems:"center"}}>
                  {reportBtns.map(r=>(
                    <button key={r.k} className="btn btn-secondary btn-sm" onClick={()=>generate(r.label,e)}>
                      <Icon name="reports" size={12}/>{r.label}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
          {filtered.length===0&&<div className="empty-state"><div className="empty-icon"><Icon name="reports" size={36}/></div><div className="empty-title">No reports</div></div>}
        </div>
      </div>
      {reportModalDoc&&(
        <div className="modal-backdrop" onClick={e=>e.target===e.currentTarget&&setReportModalDoc(null)}>
          <div className="modal" style={{maxWidth:440}}>
            <div className="modal-header">
              <div className="modal-title">{t.estimates.reportOptions}</div>
              <button className="btn-icon" title={t.common.close} onClick={()=>setReportModalDoc(null)}><Icon name="x"/></button>
            </div>
            <div className="modal-body">
              {!reportModalDoc.isProd&&(
                <div className="report-preset-cards">
                  {[["full",t.estimates.reportFull],["client",t.estimates.reportClient]].map(([key,label])=>(
                    <div key={key} className={`report-preset-card${reportPreset===key?" active":""}`} onClick={()=>applyReportPreset(key)}>
                      {label}
                    </div>
                  ))}
                </div>
              )}
              <div>
                {[
                  ["showLineItems",t.estimates.reportShowLineItems,false],
                  ["showUnitCost",t.estimates.reportShowUnitCost,true],
                  ["showUnitPrice",t.estimates.reportShowUnitPrice,true],
                  ["showLineItemTotals",t.estimates.reportShowLineItemTotals,true],
                  ["showSectionSubtotals",t.estimates.reportShowSectionSubtotals,false],
                  ["showTaxes",t.estimates.reportShowTaxes,false],
                  ...(reportModalDoc.isProd ? [["showSupplier",t.estimates.reportShowSupplier,false]] : []),
                ].map(([key,label,isChild])=>{
                  const disabled = isChild && !reportConfig.showLineItems;
                  return (
                    <div key={key} className="report-toggle-row" style={isChild?{paddingLeft:24}:{}}>
                      <input type="checkbox" id={`prod-${key}`} checked={!!reportConfig[key]} disabled={disabled} style={disabled?{opacity:0.4,pointerEvents:"none"}:{}} onChange={e=>{
                        if(key==="showLineItems"){
                          const v=e.target.checked;
                          setReportConfig(p=>({...p,showLineItems:v,showUnitCost:v?true:false,showUnitPrice:v?true:false,showLineItemTotals:v?true:false}));
                        } else {
                          setReportConfig(p=>({...p,[key]:e.target.checked}));
                        }
                        setReportPreset("custom");
                      }}/>
                      <label htmlFor={`prod-${key}`} style={disabled?{opacity:0.4,pointerEvents:"none"}:{}}>{label}</label>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={()=>setReportModalDoc(null)}>{t.estimates.cancel}</button>
              <button className="btn btn-primary" onClick={doGenerateReport}><Icon name="printer" size={14}/>{t.estimates.reportPrint}</button>
            </div>
          </div>
        </div>
      )}
      {toast&&<div style={{position:"fixed",bottom:24,left:"50%",transform:"translateX(-50%)",background:"var(--text)",color:"white",padding:"10px 20px",borderRadius:"6px",fontSize:13,zIndex:999}}>{toast}</div>}
    </div>
  );
}

export default Reports;
